<template>  
    <div class="addClerkDialog">
      <el-dialog  
          title="新增客户/供应商" 
          width="750px"
          append-to-body
          :visible.sync="visible" 
          @close="closeDialog" 
          :show="show">
          <div class="content_box">
            <InputThree class="base_select_sty2" v-model="form.FullName" @clickFocus="doFocus" @dateChange="dateChange" :name="addName" fieldData="FullName"/>
            <InputThree class="base_select_sty2 margin_l_10" v-model="form.BaseCode" @clickFocus="doFocus" @dateChange="dateChange" :name="addNumber" fieldData="BaseCode"/>
            <InputSearch class="base_select_sty2" :value="form.classVal" @clickFocus="doFocus" name="所属分类" :isMust="false" fieldData="classVal" :popType='0' :isdisable="true" v-bind="$attrs"/>
            <SelectInput class="base_select_sty2 margin_l_10" name="经手人" :popType='2' :value='form.handlersVal1' fieldData='handlersVal1' v-bind="$attrs" />
            <InputThree class="base_select_sty2" v-model="form.PyNo" @clickFocus="doFocus" @dateChange="dateChange" name="助记码" :isMust="false" :isdisable="true" fieldData="PyNo"/>
            <SelectInput class="base_select_sty2 margin_l_10" name="所属地区" :popType='3' :value='form.areaVal' fieldData='areaVal' :isdisable="true" v-bind="$attrs"/>
            <InputThree class="base_select_sty2" v-model="form.ARLimit" @clickFocus="doFocus" @dateChange="dateChange" name="应收上限" :isMust="false" fieldData="ARLimit" reg="float"/>
            <InputThree class="base_select_sty2 margin_l_10" v-model="form.APLimit" @clickFocus="doFocus" @dateChange="dateChange" name="应付上限" :isMust="false" fieldData="APLimit" reg="float"/>
            <InputThree class="base_select_sty2" v-model="form.SkLimit" @clickFocus="doFocus" @dateChange="dateChange" name="收款期限" :isMust="false" fieldData="SkLimit"/>
            <InputThree class="base_select_sty2 margin_l_10" v-model="form.Discount" @clickFocus="doFocus" @dateChange="dateChange" name="折扣" :isMust="false" fieldData="Discount" reg="float"/>
            <InputThree class="base_select_sty1" v-model="form.Memo" @clickFocus="doFocus" @dateChange="dateChange" name="备注" :isMust="false" fieldData="Memo"/>
            <span slot="footer" class="dialog-footer">
              <el-button size="mini" type="primary" @click="saveInfor">保 存</el-button>
              <el-button size="mini" @click="closeDialog">取 消</el-button>
            </span>
          </div>
      </el-dialog>
    </div>
</template>  

<script>
// 以下为工具库
import vPinyin from "@/utils/PyConversion.js";// 自动生成拼音助记码
import tool from "@/utils/tool";//本地缓存存取

export default {
    name:"addClerkDialog",
    data () {  
        return {
            visible: this.show,
            addName:'客户名称',//显示的名称栏名字
            addNumber:'客户编号',//显示的编号栏名字
            form:{
              FullName:'',//客户名称
              BaseCode:'0',//客户编号
              ParentNo:0,//父级ID（与classVal的KtypeId关联）
              EtypeId:Number(tool.getLocal("EtypeId")),//职员ID/经手人（与handlersVal1的KtypeId关联）
              PyNo:'',//拼音码
              AreaId:Number(''),//地区ID（与areaVal的KtypeId关联）
              ARLimit:99999999999,//应收上限
              APLimit:99999999999,//应付上限
              Discount:1,//折扣
              Memo:'',//备注
              IsVip:0,//是否是会员,1-会员,0-非会员
              IsClient:this.$attrs.pargam.IsClient,//0-供应商,1-客户,2-既是客户,又是供应商
              classVal:{FullName:'所有单位',KtypeId: 0},//所属分类(只为取出id值)
              handlersVal1:{FullName: tool.getLocal("FullName") , KtypeId: Number(tool.getLocal("EtypeId"))},//经手人(只为取出id值)
              areaVal:{FullName: '' , KtypeId: Number('')},//地区(只为取出id值)
            },
        };  
    },  
    props: {  
        show: {  
            type: Boolean,  
            default: false 
        },
        fieldData:String,
    },
    methods:{
      BaseCode() {
        // 收集参数
        let userid = tool.getLocal("userid");
        let sessionid = tool.getLocal("sessionid");
        let params = {
          user_id: userid, //用户id
          session_id: sessionid, //用户凭证
          table: "ClientB", //要获取的BaseCode
        };

        // 向后端发送请求
        this.request
          .post("/index/common/get_basecode", {
            jparams: JSON.stringify(params),
          })
          .then((res) => {
            let { status, description, BaseCode } = res;
            if (status == 0) {
              this.form.BaseCode = BaseCode;
            }
          });
      },
      // 获取焦点
      doFocus(){},
      // 当前input值改变
      dateChange(data,fieldData){
          // console.log(data,fieldData);
          this.form[fieldData] = data;
      },
      // 保存信息
      saveInfor(){
        let  params= {...this.form, user_id: tool.getLocal("userid") , session_id: tool.getLocal("sessionid")}
        this.request.post('/index/Client/add', {jparams:JSON.stringify(params)})
            .then(res => {
            // 接收后端发送回来的数据
                this.$message({
                  message: res.description,
                  type: 'success'
                });
                if(res.status==0){
                  this.$emit('backData', res.data,this.fieldData)
                  this.closeDialog();
                }
            })
            .catch(err => {
              console.log(err);
            });
      },
      // 关闭弹出框前回调
      closeDialog(){
        this.form={
          FullName:'',//客户名称
          BaseCode:'0',//客户编号
          ParentNo:0,//父级ID（与classVal的KtypeId关联）
          EtypeId:Number(''),//职员ID/经手人（与handlersVal1的KtypeId关联）
          PyNo:'',//拼音码
          AreaId:Number(''),//地区ID（与areaVal的KtypeId关联）
          ARLimit:Number(''),//应收上限
          APLimit:Number(''),//应付上限
          Discount:Number(''),//折扣
          Memo:'',//备注
          IsVip:0,//是否是会员,1-会员,0-非会员
          IsClient:this.$attrs.pargam.IsClient,//0-供应商,1-客户,2-既是客户,又是供应商
          classVal:{FullName:'所有单位',KtypeId: 0},//所属分类(只为取出id值)
          handlersVal1:{FullName: tool.getLocal("FullName") , KtypeId: Number(tool.getLocal("KtypeId"))},//经手人(只为取出id值)
          areaVal:{FullName: '' , KtypeId: Number('')},//地区(只为取出id值)
        },
        this.$emit('update:show', false)
      },
    },
    watch: {  
        show () {  
            this.visible = this.show;  
            if (this.visible) {
              this.BaseCode();
            }
        },
        'form.FullName':{
          handler(newVal,oldVal){
              this.form.Name= newVal;
              if(newVal!=''){
                // 调用自动生成助记码
                this.form.PyNo = vPinyin.makePy(newVal);
              }else{
                this.form.PyNo = '';
              }
            },
            deep: true,
        },
        'form.classVal':{
          handler(newVal,oldVal){
              this.form.ParentNo= newVal.KtypeId;
            },
            deep: true,
        },
        'form.handlersVal1':{
          handler(newVal,oldVal){
              this.form.EtypeId= newVal.KtypeId;
            },
            deep: true,
        },
        'form.areaVal':{
          handler(newVal,oldVal){
              this.form.AreaId= newVal.KtypeId;
            },
            deep: true,
        },
    },
    created(){
      if(this.$attrs.pargam.IsClient == 1){
        this.addName='客户名称',//显示的名称栏名字
        this.addNumber='客户编号',//显示的编号栏名字
        this.form.classVal = {FullName:'全部客户',KtypeId: 0};//所属分类(只为取出id值)
      }else{
          this.addName='供应商名称',//显示的名称栏名字
        this.addNumber='供应商编号',//显示的编号栏名字
        this.form.classVal = {FullName:'所有单位',KtypeId: 0};//所属分类(只为取出id值)
      }
    }
};  
</script>

<style lang="less">
.addClerkDialog{
  box-sizing: border-box;
  .el-dialog__header{
      background: rebeccapurple;
      // background: #4990d7;
      padding: 10px 10px 0;
      .el-dialog__title{
        color: #fff;
        font-size: 14px;
      }
      .el-dialog__headerbtn{
        top: 10px;
        right: 10px;
        .el-dialog__headerbtn .el-dialog__close{
          color: #fff;
        }
      }
  }
  .el-dialog__body{
    padding: 10px 20px;
  }
  .content_box{
    width: 100%;
    display: flex;
    flex-wrap:wrap;
    .base_select_sty1{
      width: 700px;
      margin-top: 10px;
    }
    .base_select_sty2{
      width: 345px;
      margin-top: 10px;
    }
    .margin_l_10{
      margin-left: 10px;
    }
    .dialog-footer{
      width: 100%;
      display: -webkit-box !important;
      display: box !important;
      position:relative;
      -webkit-box-pack:end;
      box-pack:end;
      margin: 20px 0 10px;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Dialog/addCustomDialog/addCustomDialog.vue